// import { useTranslation } from 'react-i18next';
import { GridCellProps, GridCustomCellProps } from '@progress/kendo-react-grid';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useBreakpoints from '../../../../../../../common/hooks/useBreakpoints';
import Button from '../../../../../../../common/widgets/Button';
import { GridCellTd } from '../../../../../../../common/widgets/Grid';
import Icons from '../../../../../../../common/widgets/Icons';
import PopoverDialog from '../../../../../../../common/widgets/PopoverDialog';
import { resources } from '../../../../../resources/resources';

export const StateCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  const { t: translate } = useTranslation();
  const activeColor = '#c9de97';
  const deactivatedColor = '#d9c1d8';
  return (
    <GridCellTd>
      <span
        className="grid-status-badge"
        style={{
          backgroundColor: `${
            dataItem.isActive ? activeColor : deactivatedColor
          }`,
        }}
      >
        {dataItem.isActive
          ? translate(resources.admin.employees.filters.stateActive)
          : translate(resources.admin.employees.filters.stateDeactivated)}
      </span>
    </GridCellTd>
  );
};

export interface ResendEmailCellProps extends GridCustomCellProps {
  handleResendEmail: (employeeId: number, employeeName: string) => void;
}

export const ResendEmail = (props: ResendEmailCellProps) => {
  const { isTablet } = useBreakpoints();
  const { dataItem, handleResendEmail } = props;
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const now = new Date();
  const today = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
  );
  const resetUserCheck = new Date(dataItem.resetUserCheck);

  const allowReset: boolean =
    dataItem.isActive &&
    dataItem.overflowCheckToResetUsers < 10 &&
    resetUserCheck < today;

  return (
    <GridCellTd {...props} className="grid-actions-cell">
      {!isTablet ? (
        <span className="grid-actions">
          {allowReset && (
            <Button
              className="btn-link grid-action-nav"
              onClick={() =>
                handleResendEmail(dataItem.employeeId, dataItem.employeeName)
              }
              loading={dataItem.isApproving}
            >
              <span className="btn-icon">
                <Icons.ResendMail />
              </span>
              <span>
                {translate(resources.admin.employees.grid.actions.reSendEmail)}
              </span>
            </Button>
          )}
          {dataItem.orderId != 0 && (
            <button
              className="btn-link grid-action-nav"
              onClick={() =>
                navigate(`employee-details/${dataItem.employeeId}`, {
                  state: { employeeName: dataItem.employeeName },
                })
              }
            >
              <span className="btn-icon">
                <Icons.ArrowButton />
              </span>
              <span className="btn-text">
                {translate(resources.admin.employees.grid.actions.viewDetails)}
              </span>
            </button>
          )}
        </span>
      ) : (
        <PopoverDialog
          className="popover-actions-list"
          placement="bottom"
          closeFromContent
          type="click"
          appendTo={document.body}
          content={
            <>
              {allowReset && (
                <Button
                  className="btn"
                  onClick={() =>
                    handleResendEmail(
                      dataItem.employeeId,
                      dataItem.employeeName,
                    )
                  }
                  loading={dataItem.isApproving}
                >
                  {translate(
                    resources.admin.employees.grid.actions.reSendEmail,
                  )}
                </Button>
              )}
              {dataItem.orderId != 0 && (
                <button
                  className="btn"
                  onClick={() =>
                    navigate(`employee-details/${dataItem.employeeId}`, {
                      state: { employeeName: dataItem.employeeName },
                    })
                  }
                >
                  {translate(
                    resources.admin.employees.grid.actions.viewDetails,
                  )}
                </button>
              )}
            </>
          }
        >
          <a className="mobile-admin-action"></a>
        </PopoverDialog>
      )}
    </GridCellTd>
  );
};

export const employeeNameCell = ({ dataItem }: GridCellProps) => (
  <GridCellTd>{dataItem.fullName}</GridCellTd>
);

export const emailCell = ({ dataItem }: GridCellProps) => (
  <GridCellTd className="grid-email">{dataItem.email}</GridCellTd>
);

export const companyNameCell = ({ dataItem }: GridCellProps) => (
  <GridCellTd>{dataItem.companyName}</GridCellTd>
);
